import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import { Contract } from '@/types/ContractType';

const RecoveryFund = ({ contract }: { contract: Contract }) => {
  // Priority: product address > agentSellerInfo > fallback
  const propertyState =
    contract?.product?.address?.state ||
    contract?.agentSellerInfo?.propertyState ||
    'N/A';

  return (
    <View style={styles.section}>
      <Text style={styles.title}>Real Estate Recovery Fund</Text>
      <Text style={styles.list}>
        A Real Estate Recovery Fund exists to reimburse any persons who have
        obtained a final civil judgment against {propertyState} real estate
        licensee (or a licensee's affiliates) owing to fraud, misrepresentation,
        or deceit in a real estate transaction and who have been unable to
        collect the judgment after exhausting all legal and equitable remedies.
      </Text>
    </View>
  );
};

export default RecoveryFund;
